module.exports = __webpack_public_path__ + "static/media/Clarity_ICON.706cbca1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/drivers/Clarity_ICON.svg
// module id = 1606
// module chunks = 0